import React from "react";
import { Routes, Route } from "react-router-dom";
import Pipeline from "./index";
import TeamWorkspaceLayout from "../Team/components/TeamWorkspaceLayout";
import { TEAM_BASE } from "../../utils/teamNavigation";

export default function TeamAwarenessPipelineRoutes({ basePath = TEAM_BASE, standalone = false }) {
  return (
    <TeamWorkspaceLayout
      basePath={basePath}
      activeSection="awareness"
      contentScroll={false}
      standalone={standalone}
    >
      <Routes>
        <Route index element={<Pipeline workspaceBasePath={basePath} />} />
      </Routes>
    </TeamWorkspaceLayout>
  );
}
